interface CookieOptions {
  expires?: Date;
  maxAge?: number;
  path?: string;
  secure?: boolean;
  sameSite?: "strict" | "lax" | "none";
}

export function setCookie(name: string, value: string, options: CookieOptions = {}): void {
  const { path = "/", secure = true, sameSite = "strict", expires, maxAge } = options;
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}`;
  if (secure) cookie += "; Secure";
  if (sameSite) cookie += `; SameSite=${sameSite}`;
  if (expires) cookie += `; expires=${expires.toUTCString()}`;
  if (maxAge !== undefined) cookie += `; max-age=${maxAge}`;
  document.cookie = cookie;
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${encodeURIComponent(name)}=([^;]*)`));
  return match ? decodeURIComponent(match[1]!) : null;
}

export function removeCookie(name: string, path = "/"): void {
  document.cookie = `${encodeURIComponent(name)}=; path=${path}; max-age=0`;
}
